/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BarterConflictItemResponseDto } from './barterConflictItemResponseDto.model';


export interface BarterConflictResponseDto { 
    concerned?: { [key: string]: Array<BarterConflictItemResponseDto>; };
    counterparty?: { [key: string]: Array<BarterConflictItemResponseDto>; };
    passed?: { [key: string]: Array<BarterConflictItemResponseDto>; };
    received?: { [key: string]: Array<BarterConflictItemResponseDto>; };
}

